import { Zap, BatteryCharging, Workflow, Check, ArrowUpRight } from "lucide-react";
import { COMPANY } from "../lib/constants";

const SOLUTIONS = [
  {
    id: "on-grid",
    icon: Zap,
    accent: "#F6B800",
    accentBg: "rgba(246,184,0,0.12)",
    title: "On-Grid Solar Systems",
    subtitle: "Grid-tied · Cost-effective",
    desc:
      "Connect directly to the utility grid, slash electricity bills with solar generation, and earn through net metering. Ideal for homes and businesses with reliable grid access.",
    benefits: [
      "Significantly reduced electricity bills",
      "Net metering & power export benefits",
      "Lowest upfront cost",
      "Minimal maintenance required",
      "Fast return on investment",
    ],
  },
  {
    id: "off-grid",
    icon: BatteryCharging,
    accent: "#2E8B57",
    accentBg: "rgba(46,139,87,0.12)",
    title: "Off-Grid Solar Systems",
    subtitle: "Battery-backed · Independent",
    desc:
      "Operate fully independent of the utility grid with battery storage — perfect for remote locations and areas prone to frequent power outages.",
    benefits: [
      "Complete energy independence",
      "Uninterrupted power 24/7",
      "Ideal for remote homes & farms",
      "No reliance on utility supply",
      "Reliable backup with battery bank",
    ],
  },
  {
    id: "hybrid",
    icon: Workflow,
    accent: "#0F4C81",
    accentBg: "rgba(15,76,129,0.10)",
    title: "Hybrid Solar Systems",
    subtitle: "Best of both worlds",
    desc:
      "Combine solar panels, battery storage and grid connectivity in one intelligent system. Get backup during outages while maximizing long-term savings.",
    benefits: [
      "Automatic backup during power cuts",
      "Maximum savings & efficiency",
      "Smart battery management",
      "Export surplus to the grid",
      "Future-ready scalable design",
    ],
  },
];

export const Solutions = () => (
  <section id="solutions" data-testid="solutions-section" className="chapter-section solutions-chapter">
    <div className="site-container">
      <div className="chapter-label tt-reveal" data-testid="solutions-chapter-label"><span>02 / YOUR ENERGY, YOUR WAY</span><span>THREE SYSTEMS. ENDLESS POSSIBILITIES.</span></div>
      <div className="section-intro tt-reveal"><div><h2 className="eyebrow" data-testid="solutions-heading">OUR SOLAR SOLUTIONS</h2><p className="section-statement">A system for<br /><span>your kind of life.</span></p></div><p>Lower bills. Greater independence. A smarter balance of both. Find the solar solution engineered around you.</p></div>
      <div className="solution-list">
        {SOLUTIONS.map((s, i) => {
          const Icon = s.icon;
          return <article key={s.id} data-testid={`solution-card-${s.id}`} className={`solution-row tt-reveal solution-${s.id}`}>
            <div className="solution-identity"><span className="solution-number eyebrow">0{i + 1}</span><Icon size={42} strokeWidth={1.3} /><span className="eyebrow">{s.subtitle}</span></div>
            <div className="solution-copy"><h3>{s.title}</h3><p>{s.desc}</p><a href={`https://wa.me/${COMPANY.whatsapp}?text=${encodeURIComponent(`Hi Tech Thrissur, I'd like to know more about ${s.title}.`)}`} target="_blank" rel="noopener noreferrer" data-testid={`solution-enquire-${s.id}`} className="solution-link">Find my solution <ArrowUpRight size={18} /></a></div>
            <ul>{s.benefits.map((b, j) => <li key={b} data-testid={`solution-${s.id}-benefit-${j}`}><Check size={16} /><span>{b}</span></li>)}</ul>
          </article>;
        })}
      </div>
    </div>
  </section>
);
